export default __webpack_public_path__ + "images/family_icon_right-c8ba77336285858d82bb9a043a779d51.svg";